/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NotificationReportEmailDetails {
    getFixupPrototypeFunction() { return NotificationReportEmailDetails.fixupPrototype; }

    static newInstance(model: Partial<NotificationReportEmailDetails>): NotificationReportEmailDetails {
        let obj = Object.assign(new NotificationReportEmailDetails(), model);
        NotificationReportEmailDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NotificationReportEmailDetails>): NotificationReportEmailDetails {
        if (!model) return null;
        return NotificationReportEmailDetails.newInstance(<NotificationReportEmailDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NotificationReportEmailDetails) {
        if (!obj) return;

        models.NotificationReportEmailDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NotificationReportEmailDetails): boolean {
        Object.setPrototypeOf(obj, NotificationReportEmailDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of recipient email addresses
     */
    to: Array<string>;

    /**
     * Email body content
     */
    message: string;

    /**
     * Email subject line
     */
    subject: string;

}
